<template>
  <div class="mt-3 flex items-center justify-between text-sm">
    <div class="text-gray-600 dark:text-gray-200">Page {{ page }} of {{ totalPages }}</div>
    <div class="flex gap-2">
      <button
        :disabled="page <= 1"
        @click="$emit('change', page - 1)"
        class="rounded border border-gray-300 dark:border-gray-500 px-3 py-1 text-gray-800 dark:text-gray-100 disabled:opacity-50"
      >Prev</button>
      <button
        :disabled="page >= totalPages"
        @click="$emit('change', page + 1)"
        class="rounded border border-gray-300 dark:border-gray-500 px-3 py-1 text-gray-800 dark:text-gray-100 disabled:opacity-50"
      >Next</button>
    </div>
  </div>
</template>

<script setup>
defineProps({ page: { type: Number, default: 1 }, totalPages: { type: Number, default: 1 } });
defineEmits(['change']);
</script>
